/* eslint-disable eag/match-named-export -- Pre-existing grab-bag file with several exports */
import {RECEIVE_NOTE_FAST_TRACK_ALL_TAGS} from '../metadaWarehouseReceiveNote/tags';

export const getPostReceiveNoteItemManualTags = (receiveNoteId: string) => [
  {type: 'receiveNoteState' as const, id: receiveNoteId},
  'receiveNoteTotalPrice' as const,
  'headerDynamicActions' as const,
  'deliveryNote' as const,
  ...RECEIVE_NOTE_FAST_TRACK_ALL_TAGS(receiveNoteId),
];

/**
 * Bare-string tags (no ID scoping) — intentional over-invalidation.
 * The patchReceiveNoteItemManual request only carries `receiveNoteItemId`,
 * not the parent `receiveNoteId`, so we cannot scope to a specific ID.
 */
export const PATCH_RECEIVE_NOTE_ITEM_MANUAL_TAGS = [
  'receiveNoteTotalPrice',
  'deliveryNote',
  'receiveNoteFastTrackItems',
  'receiveNoteFastTrackIssues',
] as const;

export const getPatchNoteItemPurchaseDateBulkTags = (headerType: string, headerId: string) =>
  headerType === 'DELIVERY_NOTE'
    ? [{type: 'deliveryNote' as const, id: headerId}, 'headerDynamicActions' as const]
    : [
        {type: 'receiveNoteState' as const, id: headerId},
        'receiveNoteTotalPrice' as const,
        'headerDynamicActions' as const,
      ];

export const getPostReceiveNoteItemsDeleteTags = (receiveNoteId: string) => [
  {type: 'receiveNoteState' as const, id: receiveNoteId},
  'receiveNoteTotalPrice' as const,
  'headerDynamicActions' as const,
  'deliveryNote' as const,
  ...RECEIVE_NOTE_FAST_TRACK_ALL_TAGS(receiveNoteId),
];
